/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../apimodel.d.ts" />

module App.Common.Directives {

	export class GroupValidateElement {

		public el: angular.IAugmentedJQuery;

		public scope: angular.IScope;

		public attributes: any;

		public attributeValue(name: string) {
			if (!this.scope || !this.attributes || typeof this.attributes[name] === 'undefined') {
				return undefined;
			}
			return this.scope.$eval(this.attributes[name]);
		};

		public modelValue() {
			return this.attributeValue('ngModel');
		}

		public viewValue() {
			if (!this.el) {
				return undefined;
			}
			return this.el.val();
		}

	}

}